import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { IsLoggedIn, Selectors } from '@grandvisionhq/auth';
import { useIntl, useSelector } from '@grandvisionhq/state';
import PreferredStoreButton from './PreferredStoreButton.js';
import usePreferredStore from '../../hooks/use-preferred-store.js';
import useUpdatePreferredStore from '../../hooks/api/use-update-preferred-store.js';
import useGetPreferredStoreCode from '../../hooks/api/use-get-preferred-store-code.js';

const PreferredStoreButtonContainer = ({ storeCode , storeName  })=>{
    const { getLabel  } = useIntl();
    const userId = useSelector(Selectors.getUserId);
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const { onHandlePreferredStoreChange  } = usePreferredStore(storeName);
    const { updatePersonalDetails , data: mutatedData , loading: isUpdating ,  } = useUpdatePreferredStore({
        onCompleted: ()=>onHandlePreferredStoreChange(isUpdating, true, 'stores.storeDetailsRoot.preferredStoreUpdate.success')
        ,
        onError: (_, label)=>{
            onHandlePreferredStoreChange(isUpdating, false, label);
        }
    });
    const { data , loading  } = useGetPreferredStoreCode();
    if (loading || !userId || !isLoggedIn) {
        return null;
    }
    const { code: preferredStoreCode  } = data !== null && data !== void 0 ? data : {};
    const isPreferredStore = storeCode === preferredStoreCode || storeCode === (mutatedData === null || mutatedData === void 0 ? void 0 : mutatedData.code);
    const onClick = ()=>updatePersonalDetails(storeCode.toString(), userId)
    ;
    return /*#__PURE__*/ React.createElement(PreferredStoreButton, {
        labels: {
            preferredStore: getLabel('stores.preferredStoreButton.active'),
            setPreferredStore: getLabel('stores.preferredStoreButton.set')
        },
        onClick: onClick,
        selected: isPreferredStore
    });
};
var PreferredStoreButtonContainer$1 = ((props)=>/*#__PURE__*/ React.createElement(IsLoggedIn, null, /*#__PURE__*/ React.createElement(PreferredStoreButtonContainer, swcHelpers.extends({}, props)))
);

export { PreferredStoreButtonContainer$1 as default };
//# sourceMappingURL=PreferredStoreButtonContainer.js.map
